import { PlainModal } from '@client/new/components/Modal/Modal';
import {
  faEnvelope,
  faArrowRotateRight,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Divider, Typography } from '@mui/material';

type ResetDomainModalProps = {
  error: string;
  isOpen: boolean;
  onClose: () => void;
  domain: string;
  openResetModal: () => void;
  openVideoModal: () => void;
};

export const ConfirmDomainErrorModal = (p: ResetDomainModalProps) => {
  return (
    <PlainModal
      isOpen={p.isOpen}
      onClose={p.onClose}
      height={'auto'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '24px',
        maxHeight: 'auto',
        maxWidth: 650,
      }}
    >
      <div className="py-3.5 px-4 flex flex-col bg-[#F5E5D2] gap-2 rounded-[10px]">
        <Typography className="font-medium">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="text-[#CC7C1E] pr-2"
          />
          Domain setup not yet confirmed
        </Typography>
        <div className="pl-6">
          <Typography className="font-medium text-sm">{p.error}</Typography>
          <Typography className="font-medium text-sm">
            Please ensure both CNAME records are set up correctly at website
            host provider.
          </Typography>
        </div>
      </div>
      <Typography>
        Note that confirmation may take a few minutes as your hosting provider
        processes the records. If the issue persists, reset the domain and begin
        again. 🙏
      </Typography>
      <Divider className="border-[#E4E4E4]" />
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-medium">Still having issues?</p>
        </div>
        <div className="flex flex-col gap-6 md:flex-row items-start md:items-center">
          {/* uncomment when video tutorial is ready */}
          {/* <Button
            variant="text"
            onClick={p.openVideoModal}
            className="px-4 py-2 w-max text-sm font-medium text-[#131313]"
          >
            <div className="flex gap-2 items-center text-sm font-medium">
              <FontAwesomeIcon icon={faVideo} />
              <span>Watch video tutorial</span>
            </div>
          </Button> */}
          <a
            href="mailto:creatorsupport@playbookapp.io"
            className="text-[#131313] px-4 py-2 pl-0"
          >
            <p className="flex gap-2 items-center text-sm font-medium">
              <FontAwesomeIcon icon={faEnvelope} />
              Contact support
            </p>
          </a>
          <Button
            variant="text"
            onClick={p.openResetModal}
            className="px-4 py-2"
          >
            <div className="flex gap-2 items-center text-[#5F1ECC]">
              <FontAwesomeIcon icon={faArrowRotateRight} />
              <span>Reset domain</span>
            </div>
          </Button>
        </div>
      </div>
      <div className="flex justify-end gap-7">
        <Button variant="contained" onClick={p.onClose}>
          Got it
        </Button>
      </div>
    </PlainModal>
  );
};
